<template>
  <v-container id="feedback" fluid tag="section">
    <div class="text-right">
      <v-btn color="cyan" @click="showFilter = !showFilter" small>
        <v-icon>mdi-filter</v-icon>
      </v-btn>
    </div>

    <v-row justify="center" v-if="showFilter">
      <v-col cols="12" md="12">
        <base-material-card
          color="cyan"
          icon="mdi-filter"
          class="px-3 py-1 small-icon"
          v-if="showFilter"
        >
          <div class="filter-close">
            <v-btn
              color="black"
              class="mr-0"
              fab
              small
              text
              @click="showFilter = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-row>
            <v-col cols="12" sm="3" md="2" lg="2">
              <z-date-picker
                :label="$i18n.t('From Date')"
                class="purple-input"
                v-model="filters.startTimeFrom"
                timestamp
              />
            </v-col>
            <v-col cols="12" sm="3" md="2" lg="2">
              <z-time-picker
                :label="$i18n.t('From Time')"
                class="purple-input"
                v-model="filters.startTimeFrom"
                timestamp="filters.startTimeFrom"
              />
            </v-col>
            <v-col cols="12" sm="3" md="2" lg="2">
              <z-date-picker
                :label="$i18n.t('Till Date')"
                class="purple-input"
                v-model="filters.startTimeTo"
                timestamp
              />
            </v-col>
            <v-col cols="12" sm="3" md="2" lg="2">
              <z-time-picker
                :label="$i18n.t('Till Time')"
                class="purple-input"
                v-model="filters.startTimeTo"
                timestamp="filters.startTimeTo"
              />
            </v-col>

            <v-col cols="12" md="2">
              <v-select
                :items="feedbackType"
                :label="$i18n.t('Feedback For')"
                v-model="filters.feedbackFor"
              ></v-select>
            </v-col>
            <v-col cols="12" md="2">
              <v-select
                :items="userFor"
                :label="$i18n.t('Feedback By')"
                v-model="filters.userType"
              ></v-select>
            </v-col>
            <v-col cols="12" md="2">
              <v-select
                :items="ratings"
                :label="$i18n.t('Rating')"
                v-model="filters.rating"
              ></v-select>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                :label="$i18n.t('Trip No')"
                class="purple-input"
                v-model="filters.tripNo"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                :label="$i18n.t('Vehicle No')"
                class="purple-input"
                v-model="filters.vehicleNo"
              />
            </v-col>
            <v-col cols="12" md="2">
              <z-country-select
                preIcon="mdi-earth"
                v-model="filters.driverCC"
                :label="$i18n.t('Code')"
                isd
                hideName
                hideFlag
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                :label="$i18n.t('Driver Phone')"
                name="login"
                prepend-icon="person"
                type="number"
                v-model="filters.driverPhone"
              />
            </v-col>
            <v-col cols="12" md="2" class="text-right">
              <v-btn
                color="info"
                class="mr-3"
                fab
                small
                dark
                @click="download()"
                :loading="loading"
              >
                <v-icon small>mdi-printer</v-icon>
              </v-btn>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-0"
                    color="grey darken"
                    fab
                    text
                    small
                    @click="clear(1)"
                    style="margin-right: 10px !important"
                    v-on="on"
                  >
                    <v-icon>mdi-cached</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Clear Filter") }}</span>
              </v-tooltip>
              <v-btn
                color="success"
                class="mr-0"
                fab
                small
                dark
                @click="search()"
                :loading="loading"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>

    <base-material-card
      icon="mdi-domain"
      :title="$i18n.t('Feedback')"
      class="px-5 py-3 small-icon"
      v-if="grid.records"
      color="primary"
    >
      <z-grid-record :grid="grid" class="grid-records" />

      <v-simple-table dense>
        <template v-slot:default>
          <thead class="thead">
            <tr>
              <th class="text-left">{{ $i18n.t("Feedback For") }}</th>
              <th class="text-left">{{ $i18n.t("Title") }}</th>
              <th class="text-left">{{ $i18n.t("User") }}</th>
              <th class="text-left">{{ $i18n.t("Rating") }}</th>
              <th class="text-left">{{ $i18n.t("Date") }}</th>
              <th class="text-left">{{ $i18n.t("Liked") }}</th>
              <th class="text-left">{{ $i18n.t("Disliked") }}</th>
            </tr>
          </thead>
          <feedback-row
            v-for="trip in grid.rows"
            :key="trip._id"
            :value="trip"
          />
        </template>
      </v-simple-table>

      <v-container>
        <v-row justify="center">
          <v-col cols="8">
            <v-container class="max-width">
              <v-pagination
                v-model="grid.page"
                class="my-4"
                :length="grid.total"
                total-visible="10"
                @input="showPage"
              ></v-pagination>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </base-material-card>
    <div class="py-3" />
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import FeedbackRow from "@/views/reports/feedback/FeedbackRow.vue";

@Component({
  components: { FeedbackRow },
})
export default class Tickets extends Vue {
  grid = {};
  rows = 100;
  url = "/api/feedback/grid?sidx=_id&sord=desc&_search=true&rows=" + this.rows;
  showFilter = false;
  feedbackType = ["Booking", "Trip", "App", "Vehicle", "Driver"];
  userFor = ["Pax", "Driver", "Escort", "Booker", "Admin"];
  ratings = ["1", "2", "3", "4", "5"];
  page = 1;
  filters = {
    startTimeFrom: null,
    startTimeTo: null,
    feedbackFor: null,
    userType: null,
    tripNo: null,
    vehicleNo: null,
    rating: null,
    liked: null,
    driverCC: 91,
    driverPhone: null,
  };

  getFilterReq() {
    let filterUrl = "";
    if (this.filters.startTimeFrom)
      filterUrl += "&startTimeFrom=" + this.filters.startTimeFrom;
    if (this.filters.startTimeTo)
      filterUrl += "&startTimeTo=" + this.filters.startTimeTo;
    if (this.filters.feedbackFor)
      filterUrl += "&feedbackFor=" + this.filters.feedbackFor;
    if (this.filters.userType)
      filterUrl += "&userType=" + this.filters.userType;
    if (this.filters.tripNo) filterUrl += "&tripNo=" + this.filters.tripNo;
    if (this.filters.vehicleNo)
      filterUrl += "&vehicleNo=" + this.filters.vehicleNo;
    if (this.filters.rating) filterUrl += "&rating=" + this.filters.rating;
    if (this.filters.liked) filterUrl += "&liked=" + this.filters.liked;
    if (this.filters.driverCC)
      filterUrl += "&driverCC=" + this.filters.driverCC;
    if (this.filters.driverPhone)
      filterUrl += "&driverPhone=" + this.filters.driverPhone;

    return filterUrl;
  }

  async search() {
    this.filterUrl = this.getFilterReq();
    common.setLoading(true);
    await this.showPage(1);
  }

  async download() {
    try {
      common.setLoading(true);
      await doGet(
        "/api/feedback/download?sord=_id&sidx=time&" + this.filterUrl
      );
      common.setLoading(false);
    } catch (e) {
      common.setLoading(false);
      common.setError(e.message);
    }
  }

  get loading() {
    return common.loading;
  }

  async mounted() {
    try {
      this.grid = await doGet(this.url);
    } catch (e) {
      common.setError(e.message);
    }
  }

  async showPage(page) {
    this.page = page;
    this.grid = await doGet(this.url + this.filterUrl + "&page=" + page);
    common.setLoading(false);
  }

  async clear() {
    this.filters = {};
    this.page = 1;
    this.search();
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
</style>
